import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { ApiStatuses, NotificationPosition } from 'coreOld/enums';
import { importPartsStatus } from 'partsOld/services/imports';

import { useNotification } from './useNotification';

const INITIAL_DELAY = 2500;

export const useCheckImportPartsStatus = (partImport, setStep) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [getStatusPending, setGetStatusPending] = useState(false);
  const { showNotification } = useNotification();

  const startCheckingStatus = () => {
    const checkTimeout = setInterval(async () => {
      try {
        if (!getStatusPending) {
          setGetStatusPending(true);

          const data = await importPartsStatus({ partImport });

          checkStatus(data, checkTimeout);
        }
      } catch (err) {}
    }, INITIAL_DELAY);
  };

  const checkStatus = (response, checkTimeout) => {
    if (response.error) {
      setGetStatusPending(false);

      showNotification({
        type: ApiStatuses.ERROR,
        message: response.error || t('serverError'),
        position: NotificationPosition.TOP,
      });

      clearInterval(checkTimeout);

      setStep(null);

      return;
    }

    onStatusSuccess(response, checkTimeout);
  };

  const onStatusSuccess = (response, checkTimeout) => {
    setGetStatusPending(false);

    if (response.finished) {
      showNotification({
        type: ApiStatuses.SUCCESS,
        message: `${response.imported} parts have been successfully imported.`,
        position: NotificationPosition.TOP,
      });

      clearInterval(checkTimeout);
      setTimeout(() => queryClient.invalidateQueries('companyParts'), 1000);
      setStep(null);

      return;
    }

    if (!response.finished) {
      showNotification({
        type: ApiStatuses.LOADING,
        message: `Imported ${response.imported} out of ${response.total} parts.`,
        position: NotificationPosition.TOP,
      });

      return;
    }
  };

  return { startCheckingStatus };
};
